import api, { ResponsePayloadWithData } from '../../../api';
import { ContentType } from '../../../api/medialink';

export type School = {
  id: string;
  name: string;
  address?: {
    city: string;
  };
};

export type TeacherAssignment = {
  id?: string;
  moduleId: string;
  materialId: string;
  materialType: 'user-material' | 'medialink';
  name: string;
  from: string;
  to: string;
  group: string;
  school: School;
  status: 'ongoing' | 'planned' | 'archived';
  contentType: ContentType;
  href?: string;
  hierarchy: {
    id: string;
    title: string;
    prefix?: string;
  }[];
  audience: {
    type: 'school' | 'smartschoolschool' | 'group' | 'member';
    schoolId: string;
    groupId?: string;
    userIds?: string[];
  };
};

export async function getTeacherAssignments(superModuleId: string, groupId?: string, memberId?: string) {
  const { data } = await api.get<ResponsePayloadWithData<TeacherAssignment[]>>(
    `/studio/user/modules/${superModuleId}/assignments/teacher`,
    {
      params: {
        groupId,
        ...(memberId ? { memberId } : {}),
      },
    },
  );

  return data.data;
}

export async function getArchivedTeacherAssignments(superModuleId: string) {
  const { data } = await api.get<ResponsePayloadWithData<TeacherAssignment[]>>(
    `/studio/user/modules/${superModuleId}/assignments/teacher/archived`,
  );

  return data.data;
}
